import React from 'react';
import AdminAnalytics from './AdminAnalytics';
import MerchantAnalytics from './MerchantAnalytics/MerchantAnalytics';
import ManagerAnalytics from './ManagerAnalytics';
import StaffAnalytics from './StaffAnalytics';

export type AnalyticsRole = 'admin' | 'merchant' | 'merchant_manager' | 'merchant_staff';

interface AnalyticsProps {
  role: AnalyticsRole;
}

const Analytics: React.FC<AnalyticsProps> = ({ role }) => {
  return (
    <>
      {role === 'admin' && <AdminAnalytics />}
      {role === 'merchant' && <MerchantAnalytics role={role} />}
      {role === 'merchant_manager' && <ManagerAnalytics />}
      {role === 'merchant_staff' && <StaffAnalytics />}
    </>
  );
};

export default Analytics;
